import {trpc} from '@features/utils/trpc';

export function useRecompile() {
  const utils = trpc.useUtils();
  return trpc.flow.recompileFlow.useMutation({
    onSuccess: async ({success, compileRes}, {flowId}) => {
      if (!success) {
        console.log('recompilation result', compileRes);
        return;
      }

      await Promise.all([
        utils.screens.getScreensWithStructure.invalidate(),
        utils.screens.getScreen.invalidate(),
        utils.flow.getFlow.invalidate({flowId}),
        utils.screens.getActiveStructure.invalidate(),
        utils.screens.getFlowScreens.invalidate({flowId}),
        utils.screens.recentUserMessages.invalidate(),
        utils.flow.getUndoStatus.invalidate({flowId}),
        utils.themes.getComponentFlowTokens.invalidate({flowId}),
      ]);
    },
  });
}
